import { getEnv } from '@shared/utils/env';

export const configProvider = () => {
  const googleMapsApi = getEnv().VITE_GOOGLE_MAPS_API;
  const transfersReportVersion = getEnv().VITE_TRANSFERS_REPORT_VERSION;
  const enableCookies = getEnv().VITE_ENABLE_COOKIES;

  return {
    googleMapsApi,
    TRANSFERS_REPORT_VERSION: transfersReportVersion || '2',
    ENABLE_COOKIES: (enableCookies || 'false') === 'true',
  };
};

const config = configProvider();

export default config;
